import React, { useEffect, useState } from "react";
import close1 from "../../Assets/svg/close1.svg"
import UserImg from "../../Assets/png/user-icon.png"
import { apiCallGeneric } from "../../services/api-service";


const Remoteview = ({ show, onHide }) => {

    const hrmsApiUrl = process.env.REACT_APP_HRMS_API_URL;
    const [atWork, setAtWork] = useState([]);
    const [atBreak, setAtBreak] = useState([]);
    const [notWork, setNotWork] = useState([]);


    const totalList = async (term) => {
        const response = await apiCallGeneric("get", `${hrmsApiUrl}remote_work`, null, {
            params: { search: term },
        });

        if (response?.status === 200 && response.data?.success === true) {
            setAtWork(response.data.data?.work ?? []);
            setAtBreak(response.data.data?.break ?? []);
            setNotWork(response.data.data?.away ?? []);
        }
    };

    useEffect(() => {
        totalList('');
    }, []);
    const debounce = (func, delay) => {
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => {
            func(...args);
          }, delay);
        };
      };
    const handleSearch = debounce((term) => {
        totalList(term);
      }, 1000);
    const modalStyle = {
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          opacity: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        },
        modal: {
          backgroundColor: "#ffffff",
          padding: "16px 24px",
          borderRadius: "16px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          width: "1166px",
          height:"425px",
          textAlign: "center",
         /*  overflowY: "auto", */
        },
      };
    return (
       /*  <Modal show={show} onHide={onHide} backdrop="static" >
            <Modal.Body className="px-4 py-4" style={{ backgroundColor: '#FFFFFF', borderRadius: '16px', fontFamily: 'Satoshi', width:'1166px' }}> */
            <div style={modalStyle.overlay}>
        <div style={modalStyle.modal}>
                <div className="d-flex justify-content-between  mb-2">
                    <div style={{ fontWeight: '700', fontSize: '16px', color: '#212129' }} >
                        Remote work
                    </div>
                    <div className="d-flex  justify-content-end" style={{ gap: '12px' }} >
                        <div>
                            <input type="search" onChange={(event) => {
               handleSearch(event.target.value);
            }} placeholder="Search" style={{ borderRadius: '100px', backgroundColor: '#F6F7F8', border: 'none', fontWeight: '400', fontSize: '14px', color: '#8790A1' }} className="px-3 py-2" />
                        </div>
                        <div>
                            <img src={close1} style={{ width: '40px', height: '40px' }} onClick={onHide} alt="" />
                        </div>

                    </div>

                </div>
                <div className="d-flex" style={{ flex: '12' }}>
                    <div className="px-3 py-2 d-flex flex-column" style={{ borderRadius: '12px', backgroundColor: '#F6F7F8', gap: '8px', height: '330px', flex: '5' }}>
                        <div style={{ fontWeight: '700', fontSize: '12px', color: '#212129', textAlign:'left' }}>
                            At Work ({atWork.length})
                        </div>


                        <div style={{ gap: '8px', overflowY: 'scroll' }} className="d-flex flex-column">
                            {atWork.map((item, index) => (
                                <div key={index} className="d-flex flex-column" style={{ gap: '8px' }}>
                                    <div style={{ borderRadius: '12px', backgroundColor: '#FFFFFF' }} className="px-2 py-2">
                                        <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                                            <div>
                                                {/* <img src={pfps} alt="Profile" /> */}
                                                <img src={item.profile != null && item.profile !== "" ? item.profile : UserImg} style={{ width: '40px', height: '40px', borderRadius: "100px" }} />
                                            </div>
                                            <div className="d-flex flex-column align-items-start" style={{ gap: '4px' }}>
                                                <div style={{ fontWeight: '500', fontSize: '13px', color: '#212129' }}>
                                                    {item.name}
                                                </div>
                                                <div style={{ fontWeight: '700', fontSize: '13px', color: '#6929E2' }}>
                                                    {item.duration ? item.duration.split('.')[0] : 'N/A'}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>


                    </div>

                    <div style={{ flex: '1' }}></div>

                    <div className="px-3 py-2 d-flex flex-column" style={{ borderRadius: '12px', backgroundColor: '#F6F7F8', gap: '8px', height: '330px', flex: '5' }}>
                        <div style={{ fontWeight: '700', fontSize: '12px', color: '#212129' , textAlign:'left' }}>
                            At Break ({atBreak.length})
                        </div>


                        <div style={{ gap: '8px', overflowY: 'scroll' }} className="d-flex flex-column">
                            {atBreak.map((item, index) => (
                                <div key={index} className="d-flex flex-column" style={{ gap: '8px' }}>
                                    <div style={{ borderRadius: '12px', backgroundColor: '#FFFFFF' }} className="px-2 py-2">
                                        <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                                            <div>
                                            <img src={item.profile != null && item.profile !== "" ? item.profile : UserImg} style={{ width: '40px', height: '40px', borderRadius: "100px" }} />
                                            </div>
                                            <div className="d-flex flex-column  align-items-start" style={{ gap: '4px' }}>
                                                <div style={{ fontWeight: '500', fontSize: '13px', color: '#212129' }}>
                                                    {item.name}
                                                </div>
                                                <div style={{ fontWeight: '700', fontSize: '13px', color: '#5DCB8C' }}>
                                                    {item.duration ? item.duration.split('.')[0] : 'N/A'}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>



                    </div>

                    <div style={{ flex: '1' }}></div>

                    <div className="px-3 py-2 d-flex flex-column" style={{ borderRadius: '12px', backgroundColor: '#F6F7F8', gap: '8px', height: '330px', flex: '5' }}>
                        <div style={{ fontWeight: '700', fontSize: '12px', color: '#212129',textAlign:'left'  }}>
                            Not Working ({notWork.length})
                        </div>


                        <div style={{ gap: '8px', overflowY: 'scroll' }} className="d-flex flex-column">
                            {notWork.map((item, index) => (
                                <div key={index} className="d-flex flex-column" style={{ gap: '8px' }}>
                                    <div style={{ borderRadius: '12px', backgroundColor: '#FFFFFF' }} className="px-2 py-2">
                                        <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                                            <div>
                                            <img src={item.profile != null && item.profile !== "" ? item.profile : UserImg} style={{ width: '40px', height: '40px', borderRadius: "100px" }} />
                                            </div>
                                            <div className="d-flex flex-column  align-items-start" style={{ gap: '4px' }}>
                                                <div style={{ fontWeight: '500', fontSize: '13px', color: '#212129' }}>
                                                    {item.name}
                                                </div>
                                                <div style={{ fontWeight: '500', fontSize: '12px', color: '#8790A1' }}>
                                                    {item.type}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>



                    </div>


                </div>
</div>
</div>





           





    );
};

export default Remoteview;


